import { AppComponent } from './app/app.component';
import { ENVIRONMENT } from './environments/environment';
import { APP_CONFIG } from '@qima-labs/app/app.config';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

declare let ENV_TYPE: 'dev' | 'pp' | 'prod';

if (ENVIRONMENT[ENV_TYPE].production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, APP_CONFIG).catch((err): void => console.error(err));
